import { EventEmitter, Input, Output, } from '@angular/core';
/**
 * A config containing properties for copy components
 */
var CopyBase = /** @class */ (function () {
    /**
     * Default constructor
     */
    function CopyBase(copyService) {
        this.copyService = copyService;
        this._copyDefaults = {
            copyBtnTooltipText: 'Copy to Clipboard',
            tooltipCopiedText: 'Copied'
        };
        /**
         * Placement for the tooltip
         */
        this.tooltipPlacement = 'top';
        /**
         * A tooltip that describes what the copy button does
         */
        this.copyBtnTooltipText = this._copyDefaults.copyBtnTooltipText;
        /**
         * A tooltip that informs user that copy action recently occurred
         */
        this.tooltipCopiedText = this._copyDefaults.tooltipCopiedText;
        /**
         * Placement for the copy button tooltip
         */
        this.copyBtnTooltipPlacement = 'top';
        /**
         * Event emitted when values are copied to the clipboard
         */
        this.onCopy = new EventEmitter();
        this._recentlyCopied = false;
    }
    Object.defineProperty(CopyBase.prototype, "recentlyCopied", {
        /**
         * Returns the flag indicating copy action has just happened
         *
         * @returns {boolean} True if copy action has been triggered
         */
        get: function () {
            return this._recentlyCopied;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Copy given value to the clipboard
     */
    CopyBase.prototype.copy = function () {
        var _this = this;
        var result = this.copyService.copy(this.value), originalCopyBtnTooltipText = this.copyBtnTooltipText;
        if (result) {
            this.onCopy.emit({
                value: this.value
            });
            this._recentlyCopied = true;
            this.copyBtnTooltipText = this.tooltipCopiedText || this._copyDefaults.tooltipCopiedText;
            setTimeout(function () {
                _this._recentlyCopied = false;
                _this.copyBtnTooltipText = originalCopyBtnTooltipText || _this._copyDefaults.copyBtnTooltipText;
            }, 3000);
        }
    };
    CopyBase.propDecorators = {
        'buttonAriaLabel': [{ type: Input, args: ['buttonAriaLabel',] },],
        'tooltipText': [{ type: Input, args: ['tooltipText',] },],
        'tooltipPlacement': [{ type: Input, args: ['tooltipPlacement',] },],
        'copyBtnTooltipText': [{ type: Input, args: ['copyBtnTooltipText',] },],
        'tooltipCopiedText': [{ type: Input, args: ['tooltipCopiedText',] },],
        'copyBtnTooltipPlacement': [{ type: Input, args: ['copyBtnTooltipPlacement',] },],
        'value': [{ type: Input, args: ['value',] },],
        'width': [{ type: Input, args: ['width',] },],
        'onCopy': [{ type: Output, args: ['onCopy',] },],
    };
    return CopyBase;
}());
export { CopyBase };
//# sourceMappingURL=copy-base.js.map